import r from"react";import e from"../Markers/Markers.js";const t=t=>r.createElement(e,{...t});export{t as default};
//# sourceMappingURL=CarTileMarkers.js.map
